export function initReferrals(): void {
  const copyBtn = document.getElementById("copy-referral-link");
  const shareBtn = document.getElementById("share-referral-link");
  const linkEl = document.getElementById("referral-link");

  if (!copyBtn || !shareBtn || !linkEl) return;

  const referralLink = linkEl.textContent?.trim() || "";

  copyBtn.addEventListener("click", async () => {
    try {
      await navigator.clipboard.writeText(referralLink);
      showCopiedFeedback(copyBtn);
    } catch {
      fallbackCopy(referralLink, copyBtn);
    }
  });

  shareBtn.addEventListener("click", async () => {
    const shareData = {
      title: "MindRank",
      text: "I'm practicing logic puzzles on MindRank. Play a few rounds and we both get 5 days of PRO for free! 🧠🎁",
      url: referralLink,
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch {
        // User cancelled or share failed - silently ignore
      }
    } else {
      // Fallback: copy to clipboard
      try {
        await navigator.clipboard.writeText(referralLink);
        showCopiedFeedback(shareBtn);
      } catch {
        fallbackCopy(referralLink, shareBtn);
      }
    }
  });
}

function showCopiedFeedback(button: HTMLElement): void {
  const originalHTML = button.innerHTML;

  button.innerHTML = `
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
    </svg>
    <span>Copied!</span>
  `;
  button.classList.remove(
    "bg-blue-600",
    "hover:bg-blue-500",
    "bg-slate-700",
    "hover:bg-slate-600",
  );
  button.classList.add("bg-emerald-600");

  setTimeout(() => {
    button.innerHTML = originalHTML;
    button.classList.remove("bg-emerald-600");
    button.classList.add("bg-blue-600", "hover:bg-blue-500");
  }, 2000);
}

function fallbackCopy(text: string, button: HTMLElement): void {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
  showCopiedFeedback(button);
}

document.addEventListener("turbo:load", () => {
  if (document.querySelector('[data-controller="referrals"]')) {
    initReferrals();
  }
});
